import * as CONSTANTS from "@/store/constants";

const filters = {
  hhTruncateHTML: function(html, stop, ellipsis) {
    if (!html || html == "null") return "";
   // Create a temporary div to parse HTML and decode entities
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    
    // Get plain text content (stripTags: true behavior)
    const plainText = (tempDiv.textContent || tempDiv.innerText || '').trim();
    
    // Split into words for byWords: true behavior
    const words = plainText.split(/\s+/).filter(word => word.length > 0);
    
    // If we have fewer words than the limit, return all text
    if (words.length <= stop) {
      return plainText;
    }
    
    // Take exactly 'stop' number of words
    const truncatedWords = words.slice(0, stop);
    let result = truncatedWords.join(' ');
    
    // Add ellipsis if provided and content was truncated
    if (ellipsis && words.length > stop) {
      result += ellipsis;
    }
    
    return result;
  },
  consistentStylesKb: function(html) {
    if (!html || html == "null") return "";
    return html
      .replace(/Help Hub/g, "Employee Hub")
      .replace(/font-size: 14pt/g, "font-size: 14px")
      .replace(/font-size: 18pt/g, "font-size: 18px")
      .replace(/font-size: 19px/g, "font-size: 14px")
      .replace(/font-size: 24px/g, "font-size: 18px")
      .replace(/font-size: 13px/g, "font-size: 14px")
      .replace(/font-size: large/g, "");
  },
  pascalCase: function(value) {
    return value.toString().replace(/(\w)(\w*)/g, function(g0, g1, g2) {
      return g1.toUpperCase() + g2.toLowerCase();
    });
  }
};

export default filters;
